// Assistant mock data used for the initial UI integration.
// This will be swapped to the agent service in a future branch.

export const conversations = [
  {
    id: 'conv-1',
    title: 'Practice Valuation Breakdown',
    preview: 'Explain my $1.02M valuation breakdown',
    timestamp: '2 hours ago',
    messages: [
      {
        id: 'msg-1',
        role: 'user',
        content: 'Explain my $1.02M valuation breakdown',
        timestamp: '2 hours ago',
      },
      {
        id: 'msg-2',
        role: 'assistant',
        content:
          "Your practice valuation of $1,021,274 is calculated using a discounted cash flow (DCF) model. Here's the breakdown:\n\n**Components:**\n- Discounted Terminal Value: $765.7K (75% of total)\n- Future Earnings Value: $255.6K (25% of total)\n\n**Key Drivers:**\n- Your EBIT of $90.4K shows strong operational efficiency\n- Terminal growth rate of 2.5% reflects sustainable long-term growth\n- Discount rate of 12% accounts for risk and opportunity cost\n\nWould you like me to explain any specific component in more detail?",
        timestamp: '2 hours ago',
      },
    ],
  },
  {
    id: 'conv-2',
    title: 'Growth Opportunities',
    preview: 'What are my best growth opportunities?',
    timestamp: '1 day ago',
    messages: [
      {
        id: 'msg-3',
        role: 'user',
        content: 'What are my best growth opportunities?',
        timestamp: '1 day ago',
      },
      {
        id: 'msg-4',
        role: 'assistant',
        content:
          'Based on your practice data, here are your top growth opportunities:\n\n**1. Geographic Expansion**\n- California shows $128.7M in AUM potential\n- Texas market has $124.1M opportunity\n- Consider strategic partnerships in these regions\n\n**2. Service Line Expansion**\n- Your current AUM suggests room for wealth management services\n- Estate planning could add 15-20% to revenue\n\n**3. Partner Network**\n- 3 potential partners match your criteria\n- Combined AUM potential: $15M\n\nShall I dive deeper into any of these opportunities?',
        timestamp: '1 day ago',
      },
    ],
  },
  {
    id: 'conv-3',
    title: 'Partner Discovery Criteria',
    preview: 'How do I find the right partners?',
    timestamp: '3 days ago',
    messages: [
      {
        id: 'msg-5',
        role: 'user',
        content: 'How do I find the right partners?',
        timestamp: '3 days ago',
      },
      {
        id: 'msg-6',
        role: 'assistant',
        content:
          'Finding the right partners involves several key criteria:\n\n**Cultural Fit:**\n- Shared values and practice philosophy\n- Compatible client service approaches\n- Similar growth ambitions\n\n**Financial Alignment:**\n- Complementary AUM ranges\n- Revenue synergies\n- Clear valuation expectations\n\n**Geographic Strategy:**\n- Market overlap or expansion opportunities\n- Regional expertise\n- Regulatory considerations\n\nI can help you refine these criteria based on your specific goals. What\'s most important to you?',
        timestamp: '3 days ago',
      },
    ],
  },
  {
    id: 'conv-4',
    title: 'EBIT Calculation',
    preview: 'What does EBIT mean and how is it calculated?',
    timestamp: '1 week ago',
    messages: [
      {
        id: 'msg-7',
        role: 'user',
        content: 'What does EBIT mean and how is it calculated?',
        timestamp: '1 week ago',
      },
      {
        id: 'msg-8',
        role: 'assistant',
        content:
          "EBIT stands for **Earnings Before Interest and Taxes**. It's a key profitability metric.\n\n**Calculation:**\n```\nEBIT = Revenue - Operating Expenses\n```\n\n**For your practice:**\n- Revenue: $450K\n- Operating Expenses: $359.6K\n- **EBIT: $90.4K**\n\n**Why it matters:**\n- Shows operational efficiency independent of financing\n- Used in valuation multiples\n- Helps compare practices of different sizes\n- Key driver of your terminal value\n\nYour EBIT margin of 20% is strong for the industry. Want to explore ways to improve it further?",
        timestamp: '1 week ago',
      },
    ],
  },
];

export const suggestedTopics = [
  {
    id: 'topic-1',
    title: 'What is my valuation?',
    description: 'Get a detailed breakdown of your practice value',
    icon: 'trending-up',
  },
  {
    id: 'topic-2',
    title: 'How ready am I for succession?',
    description: 'Assess your succession readiness and gaps',
    icon: 'target',
  },
  {
    id: 'topic-3',
    title: "What's my wealth gap?",
    description: 'Understand the gap between current and target wealth',
    icon: 'bar-chart',
  },
  {
    id: 'topic-4',
    title: 'What tasks should I focus on this quarter?',
    description: 'Get personalized recommendations for next steps',
    icon: 'check-circle',
  },
  {
    id: 'topic-5',
    title: 'How does my practice compare to peers?',
    description: 'Benchmark against similar practices',
    icon: 'users',
  },
  {
    id: 'topic-6',
    title: 'Who could be a good continuity partner for me?',
    description: 'Find potential partners that match your criteria',
    icon: 'handshake',
  },
];

export const quickPrompts = [
  'Explain my valuation methodology',
  'Show me growth opportunities',
  'How can I improve my EBIT?',
  'What are the risks to my valuation?',
  'Help me prepare for succession',
  'Find potential partners in my area',
];

export default { conversations, suggestedTopics, quickPrompts };



